import { createSlice, createAction } from "@reduxjs/toolkit";
import { RootState } from "store/store";
import {
	CommissionPolicy,
	CommissionPolicyQueryParams,
	DataUpdateCommissionPolicy,
} from "../types";

interface CommissionPolicyState {
	commissionPolicyCategories: Array<CommissionPolicy>;
	commissionPolicyCategoriesTotal: number;
	commissionPolicy?: CommissionPolicy;
}

const initialState: CommissionPolicyState = {
	commissionPolicyCategories: [],
	commissionPolicyCategoriesTotal: 0,
};

export const commissionPolicySlice = createSlice({
	name: "commissionPolicy",
	initialState,
	reducers: {
		setCommissionPolicies: (state, action) => {
			state.commissionPolicyCategories = action.payload.data;
			state.commissionPolicyCategoriesTotal = action.payload.total;
		},
		setCommissionPolicy: (state, action) => {
			state.commissionPolicy = action.payload;
		},
	},
});

export const selectCommissionPolicies = (state: RootState) =>
	state.commissionPolicy.commissionPolicyCategories;
export const selectCommissionPoliciesTotal = (state: RootState) =>
	state.commissionPolicy.commissionPolicyCategoriesTotal;
export const selectCommissionPolicy = (state: RootState) =>
	state.commissionPolicy.commissionPolicy;

export const { setCommissionPolicies, setCommissionPolicy } =
	commissionPolicySlice.actions;

export interface GetCommissionPoliciesAsyncPayload {
	query: CommissionPolicyQueryParams;
	callback?: () => void;
}
export interface GetCommissionPolicyDetailsPayload {
	id: string;
	callback?: (commissionPolicy?: CommissionPolicy) => void;
}
export interface CreateCommissionPolicyPayload {
	data: DataUpdateCommissionPolicy;
	callback: (commissionPolicy: CommissionPolicy) => void;
}
export interface UpdateCommissionPolicyPayload {
	id: string;
	data: DataUpdateCommissionPolicy;
	callback?: () => void;
}

export interface UpdateCommissionPolicyStatusPayload {
	id: string;
	status: string;
	callback?: () => void;
}

export const getCommissionPoliciesAsync = createAction(
	"commissionPolicy/getCommissionPolicies",
	(payload: GetCommissionPoliciesAsyncPayload) => ({
		payload: payload || {},
	}),
);

export const getCommissionPolicyDetailsAsync = createAction(
	"commissionPolicy/getCommissionPolicyDetails",
	(payload: GetCommissionPolicyDetailsPayload) => ({
		payload: payload,
	}),
);

export const createNewCommissionPolicyAsync = createAction(
	"commissionPolicy/createNewCommissionPolicy",
	(payload: CreateCommissionPolicyPayload) => ({
		payload: payload,
	}),
);

export const updateCommissionPolicyAsync = createAction(
	"commissionPolicy/updateCommissionPolicy",
	(payload: UpdateCommissionPolicyPayload) => ({
		payload: payload,
	}),
);

export default commissionPolicySlice.reducer;
